import moment from "moment";
import React from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { connect } from "react-redux";
import {
  addPublicFormAction,
  getPublicFormAction,
} from "../../actions/PublicFormsActions";
import {
  getLeadSourceOptionsAction,
  checkTransShortNameAction,
} from "../../actions/TransactionActions";
import { getAddressFromZipcodeAction } from "../../actions/commonActions";
import {
  getContactByEmailAction,
  getContactsActions,
  getUserRolesAction,
  buyerAgentsAction,
} from "../../actions/UserActions";
import { getSubscriptionCounterAction } from "../../actions/SubscriptionReportAction";
import APIUtil from "../../config/APIUtil";
import UrlConstants from "../../config/UrlConstants";
import {
  formatPhoneNumber,
  removeDashFromMobile,
  contigencyFormat,
  listingAgentDataFormat,
  closingAgentDataFormat,
  toastMessage,
  cryptoTokenDecode,
  getContingencyData,
  convertTimeToMinutes,
  getToday,
  currencyFormat,
  formatNumber,
  convertTZ,
  getUTCdate,
  getMinutesWithUTCTZ,
  checkObjExists,
} from "../Common/Common";
import * as code from "../../config/Constants";
import * as message from "../../config/CommonMessages";
import {
  getTransactionTypeAction,
  getTimezoneListAction,
  adminGetQuickAppointmentTemplateAction,
  getUserRolesActionNew,
  getArtistDetailsAction,
  getArtistDetailsByPublicUrlAction,
  addQuickClientAction,
  checkEmailOrMobileForQuickApp,
  getArtistAvailableDatesAction,
  createTransactionAction,
  changeTransactionStatusAction,
  createTaskAction,
  setFolderPermissionAction,
  getArtistAvailableSlotsAction,
} from "../../actions/ShopActions";
//import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";
import DatePicker from "react-datepicker";
import SelectClientOrArtist from "../Transactions/Detail/SelectClientOrArtist";
import { Edit, Close } from "@material-ui/icons";
import _ from "lodash";
import ReactHtmlParser from "react-html-parser";
import UserImage from "./../../assets/img/property-placeholder.jpg";
import { Link } from "react-router-dom";
import HeaderLogin from "../HeaderLogin/HeaderLogin";
import PhoneNumber from "../Common/phoneNumber";
import "../../assets/styles/CustomDatePicker.css";

class BookAppointment extends React.Component {
  userType = cryptoTokenDecode().usertype;
  currentType = localStorage.getItem("currentRole");
  studioName = localStorage.getItem("companyName");

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.currentRole = !!this.currentType ? this.currentType.toUpperCase() : "";
    let year = new Date()
      .getFullYear()
      .toString()
      .substr(-2);
    this.state = {
      condo: false,
      builtBefore1978: false,
      hoa: false,
      homeWarranty: false,
      draft: false,
      leadSource: "",
      emd: "0",
      otherEMD: [],
      agreedOpenPrice: 0.0,
      commission: 100.0,
      transactionType: "Tattoo",
      property: {
        image: [],
        name: this.studioName,
        street: "",
        street1: "",
        city: "",
        zipcode: "",
        state: "",
      },
      buyer: {
        email: "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
      },
      buyers: [],
      startDate: moment(),
      endDate: moment(),
      campaign: "",
      contingencies: [],
      contiUpdated: false,
      isShowPrompt: false,
      promptMsg: "",
      showLoader: false,
      fees: [],
      agentPercentage: 100,
      shortName: "DWRK" + year + Math.floor(1000 + Math.random() * 9000),
      heldBy: "",
      shortNameErr: "",
      listingAgents: [],
      closingAgents: [],
      contiChanged: false,
      listingAgentEdit: true,
      closingAgentEdit: true,
      userTimezone: "America/New_York",
      contacts: [],
      ownerId: "",
      isBookingFormEnabled: false,
      users: [],

      shortNameAccepted: undefined,
      nameBySystem: true,

      selectedDuration: "",
      eventStart: moment()
        .startOf("day")
        .add(12, "hours"),
      eventEnd: moment()
        .startOf("day")
        .add(13, "hours"),
      timezoneList: [],

      show1: false,
      role: "",
      value: "",
      callbyvalue: {},
      roleForGaurdian: "",
      dataOfChild: "",
      artist: {},
      artistFullName: "",

      clientFname: "",
      clientLname: "",
      clientEmail: "",
      clientMobile: "",
      firstNameErr: false,
      firstNameErrValidation: false,
      lastNameErr: false,
      artistErr: false,
      emailFormatErr: false,
      mobileFormatErr: false,
      mobileUnauthorized: false,
      emailUnauthorized: false,
      emailOrMobileErr: false,
      disableSubmit: false,
      dateSelected: false,
      slotSelected: false,
      dateSelectedErr: false,
      slotSelectedErr: false,
      bookAppointmentSuccess: false,

      clientRoleId: "",
      existingUserData: false,
      mobileExists: false,
      emailExists: false,
      errMsg: "",
      redirectFlag: 0,

      artistData: {},
      artistStudioData: {},
      artistNameParam: this.props.match.params.name
        ? this.props.match.params.name
        : "",

      availableDates: [],
      availableSlots: [],
      activeSlot: null,
      fetchSlotsLoader: false,
      showDateLoader: true,
      paymentLink: "",
      bookingAmount: 0,
      isCardActive: false,
    };
  }

  componentWillMount() {
    if (
      this.props.history.location.state !== undefined &&
      this.props.history.location.state.id &&
      this.props.history.location.state.ownerId
    ) {
      this.getArtistDetails(
        this.props.history.location.state.id,
        this.props.history.location.state.ownerId
      );
    } else if (this.state.artistNameParam) {
      this.getArtistDetailsByPublicUrl(this.state.artistNameParam.trim());
    } else {
      this.props.history.push({
        pathname: "/studios",
      });
    }
  }

  convertToAvailableDates = (dateStrings) => {
    // return dateStrings.map((dateString) => new Date(dateString));
    return dateStrings.map(
      (dateString) => new Date(Date.parse(dateString + "T00:00:00"))
    );
  };

  getMasterData() {
    this.props.getTransactionTypeAction();
    this.props.getTimezoneListAction().then((res) => {
      // console.log("res", res);
      this.setState({ timezoneList: res });
    });
    this.props.adminGetQuickAppointmentTemplateAction().then((res) => {
      // console.log("adminGetQuickAppointmentTemplateAction res", res);
      this.setState({
        contingencies: (res && res.data && res.data.contingencies) || [],
      });
      this.setState({ campaign: (res && res.data && res.data._id) || [] });
    });
    this.setDefaultDate(new Date());
    this.props.getUserRolesActionNew(this.state.ownerId).then((res) => {
      // console.log("this.props.roles", this.props.roles);
      if (this.props.roles && this.props.roles.length > 0) {
        this.props.roles.map((x) => {
          if (x.name === "Client") {
            this.setState({
              clientRoleId: x._id,
            });
          }
        });
      }
    });

    this.props
      .getArtistAvailableDatesAction({
        artistId: (this.state.artistData && this.state.artistData._id) || "",
        ownerId: this.state.ownerId,
      })
      .then((res) => {
        if (res && res.status === code.OK) {
          this.setState({ showDateLoader: false });

          let artistAvailableDates =
            res && res.data && res.data.availableDates
              ? this.convertToAvailableDates(res.data.availableDates)
              : [];
          console.log("artistAvailableDates", res.data.availableDates);
          this.setState({ availableDates: artistAvailableDates });
        } else {
          this.setState({ showDateLoader: false });
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        this.setState({ showDateLoader: false });
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  getArtistDetails(id, ownerId) {
    this.props
      .getArtistDetailsAction(id, ownerId)
      .then((response) => {
        if (response && response.status === 200) {
          // console.log(response.data.userType);
          // console.log(message.ACCTOWNER);
          this.setState({ showLoader: false });
          if (
            typeof response.data === "object" &&
            checkObjExists(response.data)
          ) {
            this.setState(
              {
                artistData: (response && response.data) || {},
                artistStudioData:
                  (response && response.data && response.data.studioDetails) ||
                  {},
                isBookingFormEnabled:
                  response.data.userType === message.ACCTOWNER
                    ? true
                    : response.data.isBookingFormEnabled,
                ownerId:
                  (response &&
                    response.data &&
                    response.data.studioDetails &&
                    response.data.studioDetails.ownerId) ||
                  "",
              },
              () => {
                this.getMasterData();
              }
            );
          } else {
            this.props.history.push("/studios");
          }
        } else {
          this.setState({ showLoader: false });
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
          this.props.history.push("/studios");
        }
      })
      .catch((err) => {
        this.setState({ showLoader: false });
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        this.props.history.push("/studios");
      });
  }

  getOwnerId(response) {
    if (response && response.data) {
      if (
        response.data.usertype &&
        response.data.usertype === message.ACCTOWNER
      ) {
        return response.data._id || "";
      } else if (
        response.data.usertype &&
        response.data.usertype === message.VENDOR
      ) {
        if (
          checkObjExists(response.data.studioDetails) &&
          response.data.studioDetails.ownerId
        ) {
          return response.data.studioDetails.ownerId || "";
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  getArtistDetailsByPublicUrl(urlParam) {
    this.props
      .getArtistDetailsByPublicUrlAction(urlParam)
      .then((response) => {
        if (response && response.status === 200) {
          // console.log(response.data);
          if (
            response &&
            response.data &&
            response.data.studioDetails &&
            response.data.studioDetails.hasOwnProperty("allowPublicProfile") &&
            !response.data.studioDetails.allowPublicProfile
          ) {
            let pathObj =
              response &&
              response.data &&
              response.data.studioDetails &&
              response.data.studioDetails.companyInformation &&
              response.data.studioDetails.companyInformation.publicUrl &&
              response.data.studioDetails.companyInformation.publicUrl !==
                undefined
                ? {
                    pathname:
                      "/studios/" +
                      response.data.studioDetails.companyInformation.publicUrl,
                  }
                : response &&
                  response.data &&
                  response.data.studioDetails &&
                  response.data.studioDetails.ownerId
                ? {
                    pathname: "/studioDetails",
                    state: {
                      id: response.data.studioDetails.ownerId,
                    },
                  }
                : {
                    pathname: "/studios",
                  };
            this.props.history.push(pathObj);
          }

          this.setState({ showLoader: false });
          if (
            typeof response.data === "object" &&
            checkObjExists(response.data)
          ) {
            this.setState(
              {
                artistData: (response && response.data) || {},
                artistStudioData:
                  (response && response.data && response.data.studioDetails) ||
                  {},
                ownerId: this.getOwnerId(response),
                isBookingFormEnabled: response.data.isBookingFormEnabled,
              },
              () => {
                this.getMasterData();
              }
            );
          } else {
            this.props.history.push("/studios");
          }
        } else {
          this.setState({ showLoader: false });
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
          this.props.history.push("/studios");
        }
      })
      .catch((err) => {
        this.setState({ showLoader: false });
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        this.props.history.push("/studios");
      });
  }

  getCompanyAddress = () => {
    if (
      this.state.artistStudioData &&
      this.state.artistStudioData.companyInformation
    ) {
      if (
        !!this.state.artistStudioData.companyInformation.address &&
        !!this.state.artistStudioData.companyInformation.city &&
        !!this.state.artistStudioData.companyInformation.state &&
        !!this.state.artistStudioData.companyInformation.zipcode
      ) {
        return ReactHtmlParser(
          this.state.artistStudioData.companyInformation.address +
            ", " +
            this.state.artistStudioData.companyInformation.city +
            ", <br>" +
            this.state.artistStudioData.companyInformation.state +
            " " +
            this.state.artistStudioData.companyInformation.zipcode
        );
      }
    }
    return "";
  };

  /**
   * @desc update transaction data with field name
   * @param {*} field
   * @param {*} value
   */
  updateTransactionData(field, value) {
    switch (field) {
      case "property_street":
        return (this.state.property.street = value);
      case "property_street1":
        return (this.state.property.street1 = value);
      case "property_city":
        return (this.state.property.city = value);
      case "property_state":
        return (this.state.property.state = value);
      case "property_zipcode":
        return (this.state.property.zipcode = value);
      case "property_image":
        return (this.state.property.image = value);
      case "buyer_firstname":
        return (this.state.buyer.firstname = value);
      case "buyer_lastName":
        return (this.state.buyer.lastname = value);
      case "buyer_email":
        return (this.state.buyer.email = value);
      case "buyer_mobileNumber":
        return (this.state.buyer.mobileNumber = value);
      default: {
        var fieldState = {};
        fieldState[field] = value;
        return this.setState(fieldState);
      }
    }
  }

  setMobile(value, field) {
    var mob = value.replace(/-/g, "");
    this.updateTransactionData(field, mob);
  }

  //Check unique short name
  checkShortName = (name) =>
    new Promise((resolve, reject) => {
      this.props.checkTransShortNameAction(name).then((res) => {
        let isAccepted = false;
        if (res.status === code.ACCEPTED) {
          isAccepted = true;
          this.setState({ shortNameErr: "" });
        }
        resolve({ isAccepted: isAccepted });
      });
    });

  handleEventStartChange(date, type) {
    let startDate = date;
    let endDate = moment(date).add(1, "hours");

    if (type == "time") {
      let dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");

      // Combine date and time
      let startDateTime = moment(
        `${dateStr} ${date.startTime}`,
        "YYYY-MM-DD HH:mm"
      );

      // Format the date and time in ISO 8601 format
      let startIsoString = startDateTime.toISOString();

      // Create a new Date object using the ISO string
      let newStartDate = new Date(startIsoString);

      // Combine date and time
      let endDateTime = moment(
        `${dateStr} ${date.endTime}`,
        "YYYY-MM-DD HH:mm"
      );

      // Format the date and time in ISO 8601 format
      let endIsoString = endDateTime.toISOString();

      // Create a new Date object using the ISO string
      let newEndDate = new Date(endIsoString);
      this.setState({ eventStart: newStartDate, eventEnd: newEndDate });
    } else {
      this.setState({ eventStart: startDate, eventEnd: endDate });
    }
  }

  setDuration(e) {
    // console.log("setDuration e type", typeof e);
    this.setState({
      selectedDuration: e,
    });

    // console.log("setDuration e", e);
    // console.log("this.state.eventStart", this.state.eventStart);
    let startTime = new Date(this.state.eventStart);
    let duration = parseInt(e);
    let endTime = new Date(startTime.getTime() + duration * 60000);

    // console.log("setDuration startTime", startTime);
    // console.log("setDuration duration", duration);
    // console.log("setDuration endTime", endTime);

    let eventDate = moment
      .tz(endTime, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .utc()
      .format();

    // console.log("handleEventEndChange eventDate as eventEnd", eventDate);
    this.setState({
      eventEnd: endTime,
    });
    // this.handleEventEndChange(endTime, "time");
  }

  setDefaultDate(transStartDate) {
    let defStartDate = moment
      .tz(transStartDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .utc()
      .format();

    // console.log("defStartDate", defStartDate);

    let defEndDate = moment
      .tz(defStartDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .add(1, "hours")
      .utc()
      .format();

    // console.log("defEndDate", defEndDate);

    this.setState({
      eventStart: transStartDate,
      eventEnd: moment(transStartDate).add(1, "hours"),
      selectedDuration: "60",
    });
  }

  setAssignee() {
    // console.log("setAssignee e ", e);
    let selectedArtist = [];

    selectedArtist.push({
      firstname: this.state.artistData.firstname,
      lastname: this.state.artistData.lastname,
      mobileNumber: this.state.artistData.mobileNumber,
      email: this.state.artistData.email,
      id: this.state.artistData._id,
      contactId: this.state.artistData.contactId,
    });

    // console.log("selectedArtist", selectedArtist);
    let fullName =
      this.state.artistData.firstname + " " + this.state.artistData.lastname;

    this.setState({
      artist: selectedArtist,
      artistFullName: fullName,
      artistErr: false,
    });

    this.updateTransactionData("listingAgents", selectedArtist);

    for (let k = 0; k < this.state.contingencies.length; k++) {
      if (this.state.contingencies[k].key === "First Appointment") {
        this.state.contingencies[k].assignee = this.state.artistData.contactId;
        this.state.contingencies[k].startDate = new Date(moment().minutes(0));
        this.state.contingencies[k].endDate = new Date(
          moment()
            .minutes(0)
            .add(1, "hour")
        );
      }
      if (this.state.contingencies[k].key === "Artist") {
        this.state.contingencies[k].assignee = this.state.artistData.contactId;
        this.state.contingencies[k].startDate = new Date(moment().minutes(0));
        this.state.contingencies[k].endDate = new Date(
          moment()
            .minutes(0)
            .add(1, "hour")
        );
      }
    }
  }

  checkNameValidation(value) {
    let nameRegEx = /^[A-Za-z '-]{0,50}$/;
    if (value !== "") {
      if (nameRegEx.test(value)) {
        return true; // matched format
      } else {
        return false; // not matched format
      }
    }
  }

  checkFirstNameValidation(value) {
    if (value === "") {
      this.setState({ firstNameErr: true, firstNameErrValidation: false });
    } else {
      if (!this.checkNameValidation(value)) {
        this.setState({ firstNameErrValidation: true, firstNameErr: false });
      } else {
        this.setState({ firstNameErr: false, firstNameErrValidation: false });
      }
    }
  }

  checkLastNameValidation(value) {
    if (value !== "" && !this.checkNameValidation(value)) {
      this.setState({ lastNameErr: true });
    } else {
      this.setState({ lastNameErr: false });
    }
  }

  checkEmailValidation(value) {
    let emailRegEx = new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$");
    if (value !== "") {
      if (emailRegEx.test(value)) {
        this.setState({
          emailFormatErr: false,
          existingUserData: false,
          emailUnauthorized: false,
          mobileExists: false,
          emailExists: false,
          emailOrMobileErr: false,
          mobileFormatErr: false,
        });
        this.getExistingUserData("email", value);
      } else {
        this.setState({
          emailFormatErr: true,
          existingUserData: false,
          emailUnauthorized: false,
          mobileExists: false,
          emailExists: false,
          emailOrMobileErr: false,
          mobileFormatErr: false,
        });
      }
    } else {
      this.setState({
        emailFormatErr: false,
        existingUserData: false,
        emailUnauthorized: false,
        mobileExists: false,
        emailExists: false,
        emailOrMobileErr: false,
        mobileFormatErr: false,
      });
    }
  }

  checkMobileValidation(value) {
    if (value !== "") {
      //console.log("mobile val ==>", value);
      let mob = value.replace(/-/g, "");
      // console.log("mob val ==>", mob);
      // console.log("mob length ==>", mob.length);
      if (mob.length === 10) {
        this.setState({
          mobileFormatErr: false,
          existingUserData: false,
          mobileUnauthorized: false,
          mobileExists: false,
          emailExists: false,
          emailOrMobileErr: false,
          emailFormatErr: false,
        });
        this.getExistingUserData("mobile", mob);
      } else {
        this.setState({
          mobileFormatErr: true,
          existingUserData: false,
          mobileUnauthorized: false,
          mobileExists: false,
          emailExists: false,
          emailOrMobileErr: false,
          emailFormatErr: false,
        });
      }
    } else {
      this.setState({
        mobileFormatErr: false,
        existingUserData: false,
        mobileUnauthorized: false,
        mobileExists: false,
        emailExists: false,
        emailOrMobileErr: false,
        emailFormatErr: false,
      });
    }
  }

  checkValidations(event) {
    event.preventDefault(); // Prevents default form submission behavior

    let firstNameErr = false;
    let emailOrMobileErr = false;
    let dateSelectedErr = false;
    let slotSelectedErr = false;

    if (this.state.clientFname == "") {
      this.setState({ firstNameErr: true });
      firstNameErr = true;
    }

    if (this.state.clientEmail === "" && this.state.clientMobile === "") {
      this.setState({ emailOrMobileErr: true });
      emailOrMobileErr = true;
    }

    if (!this.state.dateSelected) {
      this.setState({ dateSelectedErr: true });
      dateSelectedErr = true;
    }

    if (!this.state.slotSelected) {
      this.setState({ slotSelectedErr: true });
      slotSelectedErr = true;
    }

    if (
      !firstNameErr &&
      !emailOrMobileErr &&
      !dateSelectedErr &&
      !slotSelectedErr &&
      !this.state.lastNameErr &&
      !this.state.emailFormatErr &&
      !this.state.mobileFormatErr &&
      !this.state.emailUnauthorized &&
      !this.state.mobileUnauthorized &&
      !this.state.firstNameErrValidation
    ) {
      this.setState({
        firstNameErr: false,
        lastNameErr: false,
        emailFormatErr: false,
        mobileFormatErr: false,
        mobileUnauthorized: false,
        emailUnauthorized: false,
        firstNameErrValidation: false,
        emailOrMobileErr: false,
        disableSubmit: false,
        dateSelectedErr: false,
        slotSelectedErr: false,
      });
      // console.log("good to store ******");
      this.setState({ disableSubmit: true });
      this.createQuickClient();
    } else {
      this.setState({ disableSubmit: true });
    }
  }

  createQuickClient() {
    let clientObj = {
      firstname: this.state.clientFname ? this.state.clientFname : "",
      lastname: this.state.clientLname ? this.state.clientLname : "",
      email: this.state.clientEmail ? this.state.clientEmail : "",
      mobileNumber: this.state.clientMobile ? this.state.clientMobile : "",
      role: this.state.clientRoleId,
      usertype: "VENDOR",
      ownerId: this.state.ownerId,
      color: "",
      roles: [this.state.clientRoleId],
      isTextMsgEnabled: !!this.state.clientMobile ? true : false,
    };
    // console.log("clientObj", clientObj);

    this.props
      .addQuickClientAction(clientObj)
      .then((res) => {
        // console.log("createQuickClient res", res);
        if (res.status === code.OK) {
          if (res.data) {
            if (res.data.userData) {
              let selectedClient = [];

              selectedClient.push({
                firstname: res.data.userData.firstname
                  ? res.data.userData.firstname
                  : "",
                lastname: res.data.userData.lastname
                  ? res.data.userData.lastname
                  : "",
                mobileNumber: res.data.userData.mobileNumber
                  ? res.data.userData.mobileNumber
                  : "",
                email:
                  res.data.userData.email && res.data.userData.email.address
                    ? res.data.userData.email.address
                    : "",
                id: res.data.userData._id,
                contactId: res.data._id,
              });

              // console.log("selectedClient", selectedClient);
              //this.updateTransactionData("buyer", selectedClient);
              this.updateTransactionData("buyers", selectedClient);
            }

            for (let k = 0; k < this.state.contingencies.length; k++) {
              if (this.state.contingencies[k].key === "Client") {
                this.state.contingencies[k].assignee = res.data
                  ? res.data._id
                  : "";
                this.state.contingencies[k].startDate = new Date(
                  moment().minutes(0)
                );
                this.state.contingencies[k].endDate = new Date(
                  moment()
                    .minutes(0)
                    .add(1, "hour")
                );
              }
            }

            // console.log(
            //   "createQuickClient this.state.contingencies ",
            //   this.state.contingencies
            // );
          }
          this.setAssignee();
          this.submitAction();
        } else if (res.status === code.FORBIDDEN) {
          // console.log("res===> ", res);
          toastMessage(code.ERROR, res.data);
        } else {
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * @desc cretate transaction api call with formated data
   */
  submitAction() {
    // console.log(
    //   "submitAction this.state.contingencies ===>",
    //   this.state.contingencies
    // );

    let eventStartUTC = getUTCdate(this.state.eventStart);
    let eventEndUTC = getUTCdate(this.state.eventEnd);

    this.setState({
      showLoader: true,
    });

    for (let k = 0; k < this.state.contingencies.length; k++) {
      if (this.state.contingencies[k].key === "First Appointment") {
        this.state.contingencies[k].startDate = eventStartUTC;
        this.state.contingencies[k].endDate = eventEndUTC;
      }
    }

    let data = this.state;

    //data.contingencies = contigencyFormat(this.state.contingencies);
    data.contingencies = this.state.contingencies;

    data.startDate = new Date(data.startDate);
    data.endDate = new Date(data.endDate);

    // console.log("submit data", data);

    if (data.campaign === "") {
      delete data.campaign;
    }

    if (data.property) {
      let zip = data.property.zipcode.toString();

      if (zip.length > 5) {
        let zipcode = removeDashFromMobile(data.property.zipcode);
        data.property.zipcode = zipcode;
      }
    }

    var fileNames = [];
    var formData = new FormData();
    data.property.image.forEach((file) => {
      if (file) {
        formData.append("file", file);
        fileNames.push(file.name);
      }
    });

    if (this.state.drafted !== undefined) {
      let fees = data.fees;
      fees.push(this.state.drafted);
      data.fees = fees;
    }

    if (this.state.draftedEMD !== undefined) {
      let otherEMD = data.otherEMD;
      otherEMD.push(this.state.draftedEMD);
      data.otherEMD = otherEMD;
    }

    if (data.leadSource == "") {
      delete data.leadSource;
    }

    if (data.agentPercentage == "") {
      data.agentPercentage = this.props.profileData.agentPercentage;
    }

    //calculate amount
    let commissionAmt = (data.agreedOpenPrice * data.commission) / 100;
    let agentPercentageAmt = (commissionAmt * data.agentPercentage) / 100;
    let brokerPercentageAmt = commissionAmt - agentPercentageAmt;

    let fees = data.fees;
    fees.push({ name: "Brokerage Fee", value: brokerPercentageAmt });
    data.fees = fees;

    //default buyer
    let defaultbuyer = data.buyer;
    let multibuyers = data.buyers;

    if (
      defaultbuyer.email !== "" ||
      defaultbuyer.firstname ||
      defaultbuyer.lastname !== "" ||
      defaultbuyer.mobileNumber !== ""
    ) {
      //add default buyer on 0th index
      multibuyers.unshift(defaultbuyer);
    }

    for (let b = 0; b < multibuyers.length; b++) {
      if (!!multibuyers[b] && !!multibuyers[b].mobileNumber) {
        multibuyers[b].mobileNumber = removeDashFromMobile(
          multibuyers[b].mobileNumber.toString()
        );
      }
    }
    data.buyer = multibuyers;
    delete data.buyers;

    // data.listingAgents = listingAgentDataFormat(data.listingAgents);
    // data.closingAgents = closingAgentDataFormat(data.closingAgents);

    let TransactionData = {
      draft: data.draft,
      hoa: data.hoa,
      builtBefore1978: data.builtBefore1978,
      homeWarranty: data.homeWarranty,
      condo: data.condo,
      fees: data.fees,
      buyer: multibuyers,

      emd: data.emd,
      otherEMD: data.otherEMD,
      heldBy: data.heldBy ? data.heldBy : "Quick Appointment (Public)",
      property: data.property,
      agreedOpenPrice: data.agreedOpenPrice,
      commission: data.commission,
      leadSource: data.leadSource,
      agentPercentage: data.agentPercentage,
      listingAgents: listingAgentDataFormat(data.listingAgents),
      closingAgents: closingAgentDataFormat(data.closingAgents),
    };
    data.dsd = TransactionData;

    // console.log("final data prepared", data);

    if (data.property.image.length > 0) {
      APIUtil.postFormDataMethod(
        UrlConstants.uploadPropertyImage,
        formData,
        true
      ).then((res) => {
        data.dsd.property.image = fileNames;
        if (res.status == code.OK) {
          this.createTransaction(data);
        } else {
          data.dsd.property.image = [];
          this.createTransaction(data);
        }
      });
    } else {
      data.dsd.property.image = [];
      this.createTransaction(data);
    }
  }

  getExistingUserData(name, value) {
    if (name === "email" && value !== "") {
      // console.log("getExistingUserData email call");
      this.props
        .checkEmailOrMobileForQuickApp(name, value, this.state.ownerId)
        .then((response) => {
          let res = response.data;
          if (response.status === 401) {
            // console.log("line 775");
            this.setState({
              emailUnauthorized: true,
              errMsg: response.data,
            });
          } else {
            if (Object.keys(res).length > 0) {
              if (res.isDeleted && res.isDeleted === true) {
                // console.log("line 782");
                this.setState({
                  emailUnauthorized: true,
                  errMsg: response.data,
                });
              } else {
                // console.log("line 787");
                this.setState({
                  firstNameErr: false,
                  firstNameErrValidation: false,
                  lastNameErr: false,
                  existingUserData: true,
                  emailUnauthorized: false,
                  mobileExists: true,
                  emailExists: false,
                  emailOrMobileErr: false,
                  dateSelectedErr: false,
                  slotSelectedErr: false,
                  clientMobile: res.mobileNumber,
                  clientFname: res.firstname,
                  clientLname: res.lastname,
                  errMsg: "",
                });
              }
            } else {
              // console.log("line 799");
              this.setState({
                firstNameErr: false,
                //  firstNameErrValidation: false,
                lastNameErr: false,
                existingUserData: false,
                emailUnauthorized: false,
                mobileExists: false,
                emailExists: false,
                emailOrMobileErr: false,
                dateSelectedErr: false,
                slotSelectedErr: false,
                clientMobile: this.state.clientMobile,
                clientFname: this.state.clientFname,
                clientLname: this.state.clientLname,
                errMsg: "",
              });
            }
          }
        });
    } else if (name === "mobile" && value !== "") {
      // console.log("getExistingUserData mobile call");
      this.props
        .checkEmailOrMobileForQuickApp(name, value, this.state.ownerId)
        .then((response) => {
          let res = response.data;
          if (response.status === 401) {
            // console.log("line 816");
            this.setState({
              mobileUnauthorized: true,
              errMsg: response.data,
            });
          } else {
            if (Object.keys(res).length > 0) {
              if (res.isDeleted && res.isDeleted === true) {
                // console.log("line 823");
                this.setState({
                  mobileUnauthorized: true,
                  errMsg: response.data,
                });
              } else {
                // console.log("line 828");
                this.setState({
                  firstNameErr: false,
                  firstNameErrValidation: false,
                  lastNameErr: false,
                  existingUserData: true,
                  mobileUnauthorized: false,
                  mobileExists: false,
                  emailExists: true,
                  emailOrMobileErr: false,
                  dateSelectedErr: false,
                  slotSelectedErr: false,
                  clientEmail: res.email.address,
                  clientFname: res.firstname,
                  clientLname: res.lastname,
                  errMsg: "",
                });
              }
            } else {
              // console.log("line 840");
              this.setState({
                firstNameErr: false,
                // firstNameErrValidation: false,
                lastNameErr: false,
                existingUserData: false,
                mobileUnauthorized: false,
                mobileExists: false,
                emailExists: false,
                emailOrMobileErr: false,
                dateSelectedErr: false,
                slotSelectedErr: false,
                clientEmail: this.state.clientEmail,
                clientFname: this.state.clientFname,
                clientLname: this.state.clientLname,
                errMsg: "",
              });
            }
          }
        });
    }
  }

  /**
   * @desc call api for create new transaction with given data
   * @param {*} data
   */
  createTransaction(data, createEvent, createPublicForm, grantPermissions) {
    // createEvent set as optional param (boolean)
    if (
      createEvent === undefined ||
      createEvent === false ||
      createEvent === 0 ||
      createEvent === ""
    ) {
      createEvent = false;
    }

    if (
      createPublicForm === undefined ||
      createPublicForm === false ||
      createPublicForm === 0 ||
      createPublicForm === ""
    ) {
      createPublicForm = false;
    }

    if (
      grantPermissions === undefined ||
      grantPermissions === false ||
      grantPermissions === 0 ||
      grantPermissions === ""
    ) {
      grantPermissions = false;
    }

    this.props.createTransactionAction(data).then((res) => {
      //console.log('createTransaction res',res);
      if (this.props.isTrascationCreated === true) {
        if (!data.draft) {
          let pdata = {
            status: "INPROGRESS",
            startDate: this.props.createTransactionData.startDate,
            endDate: this.props.createTransactionData.endDate,
          };
          pdata.showSuccessMessage = false;
          // console.log("i am 143", this.props.createTransactionData);
          this.props
            .changeTransactionStatusAction(
              this.props.createTransactionData._id,
              pdata
            )
            .then((res1) => {
              this.setState({
                showLoader: false,
                bookAppointmentSuccess: true,
                disableSubmit: false,
                paymentLink: res.paymentLink ? res.paymentLink : "",
                bookingAmount: res.bookingAmount ? res.bookingAmount : 0,
                isCardActive: res.isCardActive ? res.isCardActive : false,
              });
              toastMessage(code.SUCCESS, "Appointment booked successfully");

              // creating public forms + events
              createPublicForm = true;

              // creating events
              createEvent = true;
              if (createEvent) {
                let contiDate = "";
                let contiTimeStr = "";
                let firstApptUTC = getContingencyData(
                  res.contingencies,
                  "First Appointment",
                  "startDate"
                );
                let firstApptDate = moment(firstApptUTC).format("M/DD/YYYY");
                let today = getToday();

                let eventStartUTC = getUTCdate(this.state.eventStart);
                let eventEndUTC = getUTCdate(this.state.eventEnd);
                let timeMin = getMinutesWithUTCTZ(
                  this.state.eventStart,
                  this.state.userTimezone
                );

                let newEventStart = eventStartUTC;
                let newEventEnd = eventEndUTC;
                let newEventTime = timeMin;
                let newEventAssigneeId = getContingencyData(
                  this.state.contingencies,
                  "First Appointment",
                  "assignee"
                );

                let newEvent = {
                  assignee: "@artist",
                  ownerId: this.state.ownerId,
                  clientId:
                    res && res.dsd && res.dsd.buyerId && res.dsd.buyerId[0],
                  campaign: "",
                  communicationSubject: [""],
                  communicationTo: [""],
                  communicationToUserId: [newEventAssigneeId],
                  communicationType: "EMAIL",
                  contingency: "First Appointment",
                  day: 0,
                  description: [
                    "<p>First appointment with @client_firstname @client_lastname on @first_appointment_date.</p>\n",
                  ],
                  document: false,
                  // eventEndDate: "",
                  // eventStartDate: "",
                  eventEndDate: newEventEnd,
                  eventStartDate: newEventStart,
                  eventType: "INTERACTIVE",
                  isReminder: false,
                  reminderDate: "",
                  reminderTime: 480,
                  specialTask: ["Appointment"],
                  status: "SCHEDULED",
                  time: newEventTime,
                  timeZone: "240",
                  title: "First Appointment",
                  transactionId: res._id,
                };

                if (newEvent.eventEndDate && newEvent.eventStartDate) {
                  this.props.createTaskAction(newEvent).then((res2) => {});
                }
              }
              // granting folder permissions
              grantPermissions = true;
              let hasGuardian =
                res.dsd.closingAgents.length === 0 ? false : true;
              if (grantPermissions && !hasGuardian) {
                let permissionObj = {
                  canView: true,
                  canAdd: true,
                  canMove: false,
                  canDelete: false,
                  userId: res.dsd.buyerId,
                };

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              } else {
                let permissionObj = [];

                permissionObj.push(
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.closingAgents[0].id, // guardian details for default permissions
                  },
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.buyerId[0],
                  }
                );

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              }
            });
        } else {
          this.props.history.push("/studios");
        }
      } else {
        toastMessage(code.ERROR, res);
        this.props.history.push("/studios");
      }
    });
  }

  getAvailableSlots(date) {
    this.setState({ fetchSlotsLoader: true });
    let dateStr = moment(date).format("YYYY-MM-DD");
    let data = {
      artistId: this.state.artistData && this.state.artistData._id,
      ownerId: this.state.ownerId,
      date: dateStr,
      timezone: this.state.userTimezone,
    };
    this.props.getArtistAvailableSlotsAction(data).then((res) => {
      this.setState({ fetchSlotsLoader: false });
      this.setState({
        availableSlots: res && res.data && res.data.availableTimeSlots,
      });
    });
  }

  render() {
    // if (this.state.showLoader) {
    //   return (
    //     <div className="page-loader fixed">
    //       <div className="page-loader-inner">
    //         <div className="spinner-border" role="status">
    //           <span className="sr-only">Loading...</span>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // } else {
    return (
      <div className="reg-page">
        <HeaderLogin />
        <div
          className="loginBg align-items-end flex-column"
          style={{ paddingBottom: "0px" }}
        >
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
            <Col>
              <h4 className="title-med mt-0 pt-1">Artist Details</h4>
            </Col>

            <Col className="col-auto close-icon" align="right">
              <Form inline className="justify-content-end">
                <Row className="trans-listing-head-row">
                  <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                    <div className="multi-permit">
                      <Link to="/studios" className="nav-link p-0 color-black">
                        <Close
                          style={{
                            stroke: "#fff",
                            height: "40px",
                            width: "40px",
                          }}
                        />
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          {this.state.showLoader ? (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <section className="transaction-list artist-details-wraper">
              <div
                className="container-custom"
                style={{ backgroundColor: "#379143", paddingTop: "30px" }}
              >
                <Row>
                  <div className="col-sm-6">
                    <div className="artistDetailBox">
                      <div className="imgBox">
                        <img
                          src={
                            this.state.artistStudioData &&
                            this.state.artistStudioData.companyInformation &&
                            this.state.artistStudioData.companyInformation
                              .studioLogo &&
                            this.state.artistStudioData.companyInformation
                              .studioLogo !== "-"
                              ? UrlConstants.AdminCreateTransactionUrl +
                                "/upload?id=" +
                                this.state.artistStudioData.ownerId +
                                "&img=" +
                                this.state.artistStudioData.companyInformation
                                  .studioLogo
                              : UserImage
                          }
                          alt="studio"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            let pathObj =
                              this.state.artistStudioData &&
                              this.state.artistStudioData.companyInformation &&
                              this.state.artistStudioData.companyInformation
                                .publicUrl &&
                              this.state.artistStudioData.companyInformation
                                .publicUrl !== undefined
                                ? {
                                    pathname:
                                      "/studios/" +
                                      this.state.artistStudioData
                                        .companyInformation.publicUrl,
                                  }
                                : this.state.artistStudioData &&
                                  this.state.artistStudioData.ownerId
                                ? {
                                    pathname: "/studioDetails",
                                    state: {
                                      id: this.state.artistStudioData.ownerId,
                                    },
                                  }
                                : {
                                    pathname: "/studios",
                                  };
                            this.props.history.push(pathObj);
                          }}
                        />
                      </div>
                      <div className="detailBox">
                        <h5>Studio Details</h5>
                        <div className="mb-4">
                          <h6
                            className="mb-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let pathObj =
                                this.state.artistStudioData &&
                                this.state.artistStudioData
                                  .companyInformation &&
                                this.state.artistStudioData.companyInformation
                                  .publicUrl &&
                                this.state.artistStudioData.companyInformation
                                  .publicUrl !== undefined
                                  ? {
                                      pathname:
                                        "/studios/" +
                                        this.state.artistStudioData
                                          .companyInformation.publicUrl,
                                    }
                                  : this.state.artistStudioData &&
                                    this.state.artistStudioData.ownerId
                                  ? {
                                      pathname: "/studioDetails",
                                      state: {
                                        id: this.state.artistStudioData.ownerId,
                                      },
                                    }
                                  : {
                                      pathname: "/studios",
                                    };
                              this.props.history.push(pathObj);
                            }}
                          >
                            {this.state.artistStudioData &&
                              this.state.artistStudioData.companyInformation &&
                              this.state.artistStudioData.companyInformation
                                .name}
                          </h6>
                          <p
                            className="color-grey-1 font-500 font-14"
                            style={{ lineHeight: "20px" }}
                          >
                            {this.getCompanyAddress()}
                          </p>
                        </div>

                        <div className="mb-4">
                          <h6 className="color-grey-1 font-500 font-14 mb-1">
                            Phone (Office):
                          </h6>
                          <p>
                            {this.state.artistStudioData &&
                            this.state.artistStudioData.companyInformation &&
                            this.state.artistStudioData.companyInformation
                              .phoneNumber ? (
                              <a
                                style={{ color: "black" }}
                                href={
                                  "tele:" +
                                  this.state.artistStudioData.companyInformation
                                    .phoneNumber
                                }
                              >
                                <PhoneNumber
                                  phoneNumber={
                                    this.state.artistStudioData
                                      .companyInformation.phoneNumber
                                  }
                                />
                              </a>
                            ) : (
                              "-"
                            )}
                          </p>
                        </div>
                        {this.state.artistStudioData &&
                          this.state.artistStudioData.companyInformation &&
                          this.state.artistStudioData.companyInformation
                            .website && (
                            <div className="mb-4">
                              <h6 className="color-grey-1 font-500 font-14 mb-1">
                                Website:
                              </h6>
                              <p>
                                {this.state.artistStudioData &&
                                this.state.artistStudioData
                                  .companyInformation &&
                                this.state.artistStudioData.companyInformation
                                  .website
                                  ? this.state.artistStudioData
                                      .companyInformation.website || "-"
                                  : "-"}
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="artistDetailBox">
                      <div className="imgBox">
                        <img
                          src={
                            this.state.artistData &&
                            this.state.artistData.avatar &&
                            this.state.artistData.avatar !== "-"
                              ? UrlConstants.AdminCreateTransactionUrl +
                                "/upload?id=" +
                                this.state.artistData._id +
                                "&img=" +
                                this.state.artistData.avatar
                              : UserImage
                          }
                          alt="user"
                        />
                      </div>
                      <div className="detailBox">
                        <h5>Artist Details</h5>
                        <div className="mb-4">
                          <h6 className="mb-1">
                            {this.state.artistData &&
                            this.state.artistData.firstname &&
                            this.state.artistData.lastname
                              ? this.state.artistData.firstname +
                                " " +
                                this.state.artistData.lastname
                              : "-"}
                          </h6>
                          <div
                            className="color-grey-1 font-500 font-14"
                            style={{ lineHeight: "20px" }}
                          >
                            {ReactHtmlParser(
                              this.state.artistData && this.state.artistData.bio
                                ? this.state.artistData.bio
                                : "-"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>

                {this.state.isBookingFormEnabled &&
                (this.state.artistStudioData &&
                  this.state.artistStudioData.hasOwnProperty(
                    "allowPublicScheduling"
                  ) &&
                  this.state.artistStudioData.allowPublicScheduling ===
                    true) ? (
                  <>
                    {!this.state.bookAppointmentSuccess ? (
                      <div>
                        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
                          <Col
                            xs={8}
                            sm={8}
                            className="offset-md-2 offset-sm-2"
                          >
                            <h4 className="title-med mt-0 pt-1 text-center">
                              Book Appointment
                              {/* ===
                              {this.state.isBookingFormEnabled
                                ? "True"
                                : "False"} */}
                            </h4>
                          </Col>
                        </Row>
                        <div className="multi-step multi-step-admin">
                          <div
                            className="admin-steps admin-content-area"
                            style={{ backgroundColor: "#379143" }}
                          >
                            <div className="container-custom">
                              <Form className="form-sm form-admin">
                                <Row>
                                  <Col
                                    xs={12}
                                    md={10}
                                    sm={12}
                                    xl={8}
                                    className="m-auto"
                                  >
                                    <Row>
                                      <Col xs={12} sm={6}>
                                        <div className="form-group">
                                          <label>Artwork Type</label>
                                          <div className="c-select">
                                            <select
                                              name="transactionType"
                                              className="form-control"
                                              value={this.state.transactionType}
                                              onChange={(e) => {
                                                this.updateTransactionData(
                                                  "transactionType",
                                                  e.target.value
                                                );
                                              }}
                                            >
                                              {this.props.transactionType &&
                                                this.props.transactionType
                                                  .length > 0 &&
                                                this.props.transactionType.map(
                                                  (option) => {
                                                    return (
                                                      <option
                                                        value={option.name}
                                                        key={option._id}
                                                      >
                                                        {option.name}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </select>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col xs={12} sm={6}>
                                        <div className="form-group">
                                          <label>Timezone</label>
                                          <div className="c-select">
                                            <select
                                              name="userTimezone"
                                              className="form-control"
                                              value={this.state.userTimezone}
                                              onChange={(e) => {
                                                this.setState({
                                                  disableSubmit: false,
                                                });
                                                this.updateTransactionData(
                                                  "userTimezone",
                                                  e.target.value
                                                );
                                              }}
                                            >
                                              {this.state.timezoneList &&
                                                this.state.timezoneList.length >
                                                  0 &&
                                                this.state.timezoneList.map(
                                                  (e) => {
                                                    return (
                                                      <option
                                                        key={e._id}
                                                        value={e.value}
                                                      >
                                                        {e.displayText}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </select>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    {/* <h5 className="title-small font-600 mt-2 align-mobile-text">
                                  Select Date
                                </h5> */}
                                    <Row>
                                      <Col xs={12} sm={6}>
                                        <h5
                                          className="title-small font-600 mt-2 text-center"
                                          style={{ color: "black" }}
                                        >
                                          Select Date
                                        </h5>
                                        {this.state.showDateLoader ? (
                                          <div
                                            className="loader-spinner text-center mt-4"
                                            style={{ color: "white" }}
                                          >
                                            Loading available dates, please
                                            wait...
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        <div className="form-group customDatePicker text-center">
                                          {/* <label className="date-label">Date</label> */}
                                          <DatePicker
                                            selected={
                                              new Date(this.state.eventStart)
                                            }
                                            onChange={(date) => {
                                              this.setState({
                                                disableSubmit: false,
                                                dateSelected: true,
                                                dateSelectedErr: false,
                                              });
                                              this.getAvailableSlots(date);
                                              this.handleEventStartChange(
                                                date,
                                                "date"
                                              );
                                            }}
                                            includeDates={
                                              this.state.availableDates
                                            }
                                            //filterDate={(d) => this.state.availableDates}
                                            dateFormat="MM-d-yyyy"
                                            inline
                                          />
                                        </div>
                                        {this.state.dateSelectedErr && (
                                          <div
                                            className="invalid-feedback"
                                            style={{
                                              display: "block",
                                              color: "white",
                                            }}
                                          >
                                            {message.SELECT_DATE}
                                          </div>
                                        )}
                                      </Col>
                                      <div className="col-md-6 col-xs-12 number-slot-three">
                                        <h5
                                          className="title-small font-600 mt-2 text-center"
                                          style={{ color: "black" }}
                                        >
                                          Select a Slot
                                        </h5>
                                        {this.state.fetchSlotsLoader ? (
                                          <div
                                            className="loader-spinner text-center mt-4"
                                            style={{ color: "white" }}
                                          >
                                            Loading available slots, please
                                            wait...
                                          </div>
                                        ) : (
                                          <ul className="mt-4">
                                            {this.state.availableSlots &&
                                            this.state.availableSlots.length >
                                              0 ? (
                                              this.state.availableSlots.map(
                                                (slot, index) => {
                                                  return (
                                                    <li
                                                      key={index}
                                                      onClick={() => {
                                                        this.setState({
                                                          disableSubmit: false,
                                                          slotSelected: true,
                                                          slotSelectedErr: false,
                                                        });
                                                        this.setState({
                                                          activeSlot: index,
                                                        });
                                                        this.handleEventStartChange(
                                                          slot,
                                                          "time"
                                                        );
                                                      }}
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className={
                                                        this.state
                                                          .activeSlot === index
                                                          ? "slotActive"
                                                          : ""
                                                      }
                                                    >
                                                      {moment(
                                                        slot.startTime,
                                                        "HH:mm"
                                                      ).format("h:mm a")}{" "}
                                                      -{" "}
                                                      {moment(
                                                        slot.endTime,
                                                        "HH:mm"
                                                      ).format("h:mm a")}
                                                    </li>
                                                  );
                                                }
                                              )
                                            ) : this.state.dateSelected &&
                                              !this.state.fetchSlotsLoader ? (
                                              <>
                                                <p
                                                  className="text-center"
                                                  style={{ color: "white" }}
                                                >
                                                  Booking slots not available
                                                  for selected date, please
                                                  select another date
                                                </p>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </ul>
                                        )}
                                        {this.state.dateSelected &&
                                          !this.state.fetchSlotsLoader &&
                                          this.state.slotSelectedErr && (
                                            <div
                                              className="invalid-feedback"
                                              style={{
                                                display: "block",
                                                color: "white",
                                              }}
                                            >
                                              {message.SELECT_SLOT}
                                            </div>
                                          )}
                                      </div>
                                    </Row>
                                    {this.state.dateSelected &&
                                      !this.state.fetchSlotsLoader &&
                                      this.state.slotSelected && (
                                        <>
                                          <h4 className="title-small font-600 mt-4">
                                            Client
                                          </h4>
                                          <Row>
                                            <Col xs={12} sm={6}>
                                              <div className="form-group">
                                                <label>
                                                  First Name
                                                  <span
                                                    style={{
                                                      color: "white",
                                                    }}
                                                  >
                                                    {" "}
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  name="firstname"
                                                  className="form-control field_ucfirst"
                                                  value={this.state.clientFname}
                                                  onChange={(e) => {
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.updateTransactionData(
                                                      "clientFname",
                                                      e.target.value
                                                    );
                                                  }}
                                                  onBlur={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.checkFirstNameValidation(
                                                      e.target.value
                                                    );
                                                  }}
                                                  disabled={
                                                    this.state.existingUserData
                                                  }
                                                />
                                                {this.state.firstNameErr && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {message.ENTER_FIRST_NAME}
                                                  </div>
                                                )}
                                                {this.state
                                                  .firstNameErrValidation && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {
                                                      message.ENTER_VALID_FIRST_NAME
                                                    }
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                            <Col xs={12} sm={6}>
                                              <div className="form-group">
                                                <label>Last Name</label>
                                                <input
                                                  type="text"
                                                  name="lastname"
                                                  className="form-control field_ucfirst"
                                                  value={this.state.clientLname}
                                                  onChange={(e) => {
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.updateTransactionData(
                                                      "clientLname",
                                                      e.target.value
                                                    );
                                                  }}
                                                  onBlur={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.checkLastNameValidation(
                                                      e.target.value
                                                    );
                                                  }}
                                                  disabled={
                                                    this.state.existingUserData
                                                  }
                                                />
                                                {this.state.lastNameErr && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {
                                                      message.ENTER_VALID_LAST_NAME
                                                    }
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col xs={12} sm={6}>
                                              <div className="form-group">
                                                <label>Email</label>
                                                <input
                                                  type="email"
                                                  className="form-control"
                                                  name="email"
                                                  value={this.state.clientEmail}
                                                  onChange={(e) => {
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.updateTransactionData(
                                                      "clientEmail",
                                                      e.target.value
                                                    );
                                                  }}
                                                  onBlur={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.checkEmailValidation(
                                                      e.target.value
                                                    );
                                                  }}
                                                  disabled={
                                                    this.state.emailExists
                                                  }
                                                />
                                                {this.state
                                                  .emailOrMobileErr && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {
                                                      message.ENTER_EMAIL_OR_MOBILE
                                                    }
                                                  </div>
                                                )}
                                                {this.state.emailFormatErr && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {message.ENTER_VALID_EMAIL}
                                                  </div>
                                                )}
                                                {this.state
                                                  .emailUnauthorized && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {this.state.errMsg}
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                            <Col xs={12} sm={6}>
                                              <div className="form-group">
                                                <label>Mobile Number</label>
                                                <InputMask
                                                  mask="999-999-9999"
                                                  maskChar=""
                                                  formcontrolprops={{
                                                    fullWidth: true,
                                                  }}
                                                  className="form-control"
                                                  name="mobileNumber"
                                                  value={
                                                    this.state.clientMobile
                                                  }
                                                  onChange={(e) => {
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.setMobile(
                                                      e.target.value,
                                                      "clientMobile"
                                                    );
                                                  }}
                                                  onBlur={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                      disableSubmit: false,
                                                    });
                                                    this.checkMobileValidation(
                                                      e.target.value
                                                    );
                                                  }}
                                                  disabled={
                                                    this.state.mobileExists
                                                  }
                                                >
                                                  {/* {(inputProps) => <input {...inputProps} />} */}
                                                </InputMask>
                                                {this.state.mobileFormatErr && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {message.ENTER_VALID_MOBILE}
                                                  </div>
                                                )}
                                                {this.state
                                                  .mobileUnauthorized && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{
                                                      display: "block",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {this.state.errMsg}
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <div className="mt-3 custom-privacy bg-white">
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  By submitting this form and
                                                  giving your mobile number, you
                                                  consent to receive text
                                                  messages about your
                                                  appointment, including but not
                                                  limited to reminders and
                                                  follow-ups from DotWork at the
                                                  number provided. Consent is
                                                  not a condition of purchase.
                                                  Msg &amp; data rates may
                                                  apply. Msg frequency varies.
                                                  Unsubscribe at any time by
                                                  replying STOP. Reply HELP for
                                                  help.{" "}
                                                  <a
                                                    href="https://www.dotworksoftware.com/privacy-policy"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    Privacy Policy
                                                  </a>{" "}
                                                  &amp;{" "}
                                                  <a
                                                    href="https://www.dotworksoftware.com/terms-of-service"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    Terms of Service
                                                  </a>
                                                  .
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>
                                        </>
                                      )}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Button
                                        variant="primary"
                                        size="sm"
                                        className="btn-blue w-140 mb-5 mt-5"
                                        onClick={(event) => {
                                          // window.scrollTo(0, 0);
                                          this.checkValidations(event);
                                        }}
                                        disabled={this.state.disableSubmit}
                                      >
                                        Book Appointment
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Row>
                          <Col
                            xs={8}
                            sm={8}
                            className="offset-md-2 offset-sm-2 bookAppSuccessContainer"
                          >
                            <h3 className="bookAppSuccessHeader text-center">
                              Thank you for booking an appointment.
                            </h3>
                            <div className="bookAppSuccessBody text-center">
                              <p>Appointment details are as below:</p>
                              <p>
                                <b>Artist Name: </b>
                                {this.state.artistData &&
                                this.state.artistData.firstname &&
                                this.state.artistData.lastname
                                  ? this.state.artistData.firstname +
                                    " " +
                                    this.state.artistData.lastname
                                  : "-"}
                              </p>
                              <p>
                                <b>Appointment date: </b>
                                {moment(this.state.eventStart)
                                  .tz(this.state.userTimezone)
                                  .format("Do MMM YYYY")}
                              </p>
                              <p>
                                <b>Appointment time: </b>
                                {moment(this.state.eventStart)
                                  .tz(this.state.userTimezone)
                                  .format("h:mm a")}{" "}
                                -{" "}
                                {moment(this.state.eventEnd)
                                  .tz(this.state.userTimezone)
                                  .format("h:mm a")}
                              </p>
                              {this.state.isCardActive && (
                                <Row>
                                  <Col>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Button
                                        variant="primary"
                                        size="sm"
                                        className="btn-blue w-140 mb-5 mt-5"
                                        onClick={() => {
                                          window.open(
                                            `${this.state.paymentLink}`,
                                            "_blank"
                                          );
                                        }}
                                        disabled={
                                          this.state.paymentLink ? false : true
                                        }
                                      >
                                        Pay ${this.state.bookingAmount}
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="blankDiv" />
                )}
              </div>
            </section>
          )}
        </div>
      </div>
    );
    // }
  }
}

const mapStateToProps = (state) => {
  return {
    isTrascationCreated: state.reducer.isTrascationCreated,
    createTransactionData: state.reducer.createTransactionData,
    leadSourceOptions: state.reducer.options,
    profileData: state.reducer.profileData,
    timezoneList: state.reducer.timezoneList,
    transactionType: state.reducer.transactionType,
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    taskData: state.reducer.taskData,
    buyerAgents: state.reducer.buyerAgents,
    addPublicFormData: state.reducer.addPublicFormData,
    getPublicFormData: state.reducer.getPublicFormData,
    contact: state.reducer.contact,
    artistAvailableDates: state.reducer.artistAvailableDates,
  };
};

export default connect(
  mapStateToProps,
  {
    createTransactionAction,
    getLeadSourceOptionsAction,
    getAddressFromZipcodeAction,
    checkTransShortNameAction,
    changeTransactionStatusAction,
    getContactByEmailAction,
    getSubscriptionCounterAction,
    getTimezoneListAction,
    getTransactionTypeAction,
    getContactsActions,
    getUserRolesAction,
    createTaskAction,
    buyerAgentsAction,
    addPublicFormAction,
    getPublicFormAction,
    setFolderPermissionAction,
    adminGetQuickAppointmentTemplateAction,
    addQuickClientAction,
    getUserRolesActionNew,
    checkEmailOrMobileForQuickApp,
    getArtistDetailsAction,
    getArtistDetailsByPublicUrlAction,
    getArtistAvailableDatesAction,
    getArtistAvailableSlotsAction,
  }
)(BookAppointment);
